/* DearEm – em-customizer-overlap.js (v26.1 · 23/10/2026; gốc v24.5)
 * Chạy SAU dearem-customizer-v6-17.js và dearem-photo-customizer-v17-3.js (cả hai defer, đúng thứ tự).
 * 1) Bỏ "chế độ an toàn": kéo / phóng to chữ hay icon KHÔNG còn tự thu nhỏ hoặc tự dời phần còn lại.
 *    Luôn ở chế độ tự do, ẩn nút bật/tắt chế độ tự do.
 * 2) Khi có 2 lớp chồng lên nhau → chỉ hiện cảnh báo (không chặn thêm vào giỏ).
 *    v24.6: cảnh báo hiện NGAY TRONG dòng chữ có sẵn (dòng gợi ý dưới khung thiết kế + đoạn giới thiệu ở bước xác nhận),
 *    không chèn khung mới → không xô lệch bố cục. v24.7: câu ngắn lại cho vừa điện thoại.
 * 3) Thiết kế có lớp chồng nhau → gắn property ẩn "_Lưu ý xưởng" vào dòng đơn để xưởng kiểm tra.
 * Giữ nguyên: không kéo ra ngoài vùng thêu, chữ dài quá vùng thêu vẫn tự co cho vừa vùng.
 * v26.1 (23/10/2026, CEO): cảnh báo chỉ hiện khi NÉT chữ / icon chạm nhau thật, không phải khi 2 khung chữ nhật chạm.
 *   Khung chữ nhật chỉ dùng để lọc nhanh; nếu khung chạm thì vẽ riêng từng lớp (D.renderRaw, nền trong suốt)
 *   rồi so từng điểm ảnh: nét 2 lớp chạm nhau hoặc cách ≤ 2px trên ảnh 700px (~0,3%, mắt thường coi là dính) → mới cảnh báo.
 *   Chạy sau khi ngừng kéo ~150ms, có cache theo thiết kế. Không vẽ được (lỗi) → dùng cách cũ theo khung.
 */
(function () {
  'use strict';
  function emRun() {
  if (window.__emOvlRan) return; window.__emOvlRan = 1;
  var MSG = 'Chi tiết đang chồng nhau, khó thêu/in đẹp. Dear eM sẽ cần chỉnh lại.';
  var FLAG_KEY = '_Lưu ý xưởng';
  var FLAG_VAL = 'Thiết kế có chi tiết chồng nhau – kiểm tra / căn lại trước khi sản xuất';

  var st = document.createElement('style');
  st.textContent =
    '.dmc-tool--free{display:none!important}.dmc-modal.is-free .dmc-sel{border-style:solid}' +
    '.em-ovl-on{color:#b42318!important;font-weight:600!important;line-height:1.3!important;white-space:normal!important}' +
    '.dmc-stage__bar:has(.em-ovl-on){border-radius:14px!important}' +
    '.dmc-note.em-ovl-on,.dmp-note.em-ovl-on{display:block!important}';
  document.head.appendChild(st);

  /* đổi chữ của phần tử có sẵn sang cảnh báo, tắt thì trả lại chữ cũ */
  function swap(el, on) {
    if (!el) return;
    if (on) {
      if (!el.__emOn) { el.__emOrig = el.textContent; el.__emOn = 1; }
      if (el.textContent !== MSG) el.textContent = MSG;
      el.classList.add('em-ovl-on'); el.setAttribute('role', 'status');
    } else if (el.__emOn) {
      el.__emOn = 0; el.textContent = el.__emOrig || ''; el.classList.remove('em-ovl-on'); el.removeAttribute('role');
    }
  }
  function setWarn(self, on) { (self.__emWarn || []).forEach(function (w) { swap(w, on); }); }
  function addFlag(form) {
    if (!form) return;
    var i = document.createElement('input');
    i.type = 'hidden'; i.name = 'properties[' + FLAG_KEY + ']'; i.value = FLAG_VAL; i.setAttribute('data-dmc-prop', '1');
    form.appendChild(i);
  }
  function placeWarn(self, list) { if (!self.__emWarn) self.__emWarn = list.filter(Boolean); }

  /* ================= Customizer chữ + icon (v6) ================= */
  (function () {
    var D = window.DearEmCustomizer, C = D && D.Customizer;
    if (!C || C.__emOvl) return; C.__emOvl = 1;
    var P = C.prototype;
    function flowerTemplate(t) {
      return t && (t.iconRequired === true || (Array.isArray(t.icons) && t.icons.length > 0 && t.icons.every(function (i) { return /^hoa-/.test(i.id || ''); })));
    }
    function hasRequiredFlower(self, d) {
      return !!(d && (self.t.icons || []).some(function (i) { return i.id === d.icon && /^hoa-/.test(i.id || ''); }));
    }
    var flowerMessage = 'Bạn chọn hoa tháng sinh để tiếp tục nhé.';
    var flowerValidate = P.validate;
    P.validate = function () {
      if (flowerTemplate(this.t)) {
        this.t.iconRequired = true;
        if (!hasRequiredFlower(this, this.draft)) return flowerMessage;
      }
      return flowerValidate.apply(this, arguments);
    };
    function syncFlower(self) {
      if (!flowerTemplate(self.t) || !self.modal) return;
      self.t.iconRequired = true;
      var missing = !hasRequiredFlower(self, self.draft);
      var next = self.modal.querySelector('[data-dmc-save-add]');
      if (next) { next.disabled = missing; next.setAttribute('aria-disabled', String(missing)); }
      if (missing) {
        self.confirmed = false;
        if (self.err) { self.err.textContent = flowerMessage; self.err.classList.add('is-visible'); self.err.setAttribute('role', 'status'); }
      } else if (self.err && self.err.textContent === flowerMessage) {
        self.err.textContent = ''; self.err.classList.remove('is-visible');
      }
    }
    var flowerRender = P.render;
    P.render = function () { var r = flowerRender.apply(this, arguments); syncFlower(this); return r; };
    var flowerConfirm = P.showConfirm;
    P.showConfirm = function () {
      if (flowerTemplate(this.t) && !hasRequiredFlower(this, this.draft)) {
        this.hideConfirm(); this.activeEl = 'icon'; this.render(); return;
      }
      return flowerConfirm.apply(this, arguments);
    };

    function multi(self) { var t = self.t || {}; return !t.iconAnchor && !t.lockPosition; }
    var LAYERS = ['text', 'icon', 'text2', 'icon2'];
    /* các cặp lớp có KHUNG chữ nhật chạm nhau (lọc nhanh) */
    function boxPairs(self) {
      if (!multi(self) || !self.draft || !self.boxes) return [];
      var b; try { b = self.boxes(); } catch (e) { return []; }
      if (!b) return [];
      var ks = LAYERS.filter(function (k) { return b[k]; }), tol = 0.4, out = [];
      for (var i = 0; i < ks.length; i++) for (var j = i + 1; j < ks.length; j++) {
        var A = b[ks[i]], B = b[ks[j]];
        if (Math.abs(A.cx - B.cx) < A.hw + B.hw - tol && Math.abs(A.cy - B.cy) < A.hh + B.hh - tol) out.push([ks[i], ks[j]]);
      }
      return out;
    }
    /* thiết kế chỉ còn 1 lớp (các lớp khác để trống) */
    function only(d, k) {
      var c = JSON.parse(JSON.stringify(d));
      LAYERS.forEach(function (x) { if (x !== k) c[x] = ''; });
      return c;
    }
    var SZ = 700, A_MIN = 60, GAP = 2; /* nét cách nhau ≤ 2px (trên ảnh 700px, ~0,3%) coi như chạm */
    function alphaOf(cv) {
      if (cv.width !== SZ || cv.height !== SZ) {
        var c2 = document.createElement('canvas'); c2.width = c2.height = SZ;
        c2.getContext('2d').drawImage(cv, 0, 0, SZ, SZ); cv = c2;
      }
      return cv.getContext('2d').getImageData(0, 0, SZ, SZ).data;
    }
    /* so điểm ảnh: true = nét 2 lớp thật sự chạm nhau */
    function inkTouch(self, pairs) {
      var D = window.DearEmCustomizer, R = D && (D.renderRaw || D.renderDesignImage);
      if (!R) return Promise.reject(new Error('no renderer'));
      var need = {}; pairs.forEach(function (p) { need[p[0]] = need[p[1]] = 1; });
      var keys = Object.keys(need), d = self.draft, t = self.t;
      return Promise.all(keys.map(function (k) { return R(t, only(d, k), false, SZ); })).then(function (cvs) {
        var al = {}; keys.forEach(function (k, i) { al[k] = alphaOf(cvs[i]); });
        return pairs.some(function (p) {
          var a = al[p[0]], b = al[p[1]], m = new Uint8Array(SZ * SZ), i, x, y, dx, dy, xx, yy;
          for (i = 3; i < a.length; i += 4) if (a[i] > A_MIN) m[(i - 3) >> 2] = 1;
          for (i = 3; i < b.length; i += 4) {
            if (b[i] <= A_MIN) continue;
            x = ((i - 3) >> 2) % SZ; y = ((i - 3) >> 2) / SZ | 0;
            for (dy = -GAP; dy <= GAP; dy++) for (dx = -GAP; dx <= GAP; dx++) {
              xx = x + dx; yy = y + dy;
              if (xx >= 0 && yy >= 0 && xx < SZ && yy < SZ && m[yy * SZ + xx]) return true;
            }
          }
          return false;
        });
      });
    }
    function keyOf(self, pairs) {
      try { return JSON.stringify([self.draft, self.variant && self.variant.id, pairs]); } catch (e) { return String(Math.random()); }
    }
    /* kết quả hiện tại (đồng bộ): khung không chạm → false; khung chạm → kết quả so điểm ảnh nếu đã có, chưa có thì tạm theo khung */
    function overlaps(self) {
      var pairs = boxPairs(self);
      if (!pairs.length) return false;
      var k = keyOf(self, pairs), c = self.__emInk;
      if (c && c.key === k && c.done) return c.val;
      return true;
    }
    /* chạy so điểm ảnh sau khi ngừng thao tác 150ms, rồi cập nhật cảnh báo */
    function check(self) {
      var pairs = boxPairs(self);
      clearTimeout(self.__emInkT);
      if (!pairs.length) { self.__emNow = false; setWarn(self, false); return; }
      var k = keyOf(self, pairs), c = self.__emInk;
      if (c && c.key === k) { if (c.done) { self.__emNow = c.val; setWarn(self, c.val); } return; }
      self.__emInkT = setTimeout(function () {
        var job = self.__emInk = { key: k, done: false, val: true };
        inkTouch(self, pairs).then(function (v) { job.val = v; }, function () { job.val = true; /* lỗi → giữ cách cũ */ })
          .then(function () {
            job.done = true;
            if (self.__emInk !== job) return;
            var cur = boxPairs(self);
            if (!cur.length || keyOf(self, cur) !== k) return;
            self.__emNow = job.val; setWarn(self, job.val);
          });
      }, 150);
    }
    function ensure(self) {
      if (!self.modal) return;
      placeWarn(self, [self.modal.querySelector('.dmc-tip'), self.modal.querySelector('[data-dmc-confirm] .dmc-note')]);
    }
    function goFree(self) {
      if (!multi(self) || !self.setFree) return;
      self.setFree(true);
      if (self.tipEl && self.tip0) { if (self.tipEl.__emOn) self.tipEl.__emOrig = self.tip0; else self.tipEl.textContent = self.tip0; }
    }
    var _op = P.open;
    P.open = function () {
      if (multi(this)) this.freeMode = false; // tránh v6 gọi setFree(false) → fit() tự thu nhỏ khi mở lại
      var r = _op.apply(this, arguments);
      ensure(this); goFree(this);
      return r;
    };
    var _rn = P.render;
    P.render = function () {
      var r = _rn.apply(this, arguments);
      try { ensure(this); check(this); } catch (e) {}
      return r;
    };
    var _sv = P.save;
    P.save = function () {
      var prev = this.__emState, now = false;
      try { now = overlaps(this); } catch (e) {}
      this.__emState = now;
      var r = _sv.apply(this, arguments);
      if (!r) this.__emState = prev;
      return r;
    };
    var _wp = P.writeProperties;
    P.writeProperties = function () {
      var r = _wp.apply(this, arguments);
      try { if (this.state && this.__emState) addFlag(this.form); } catch (e) {}
      return r;
    };
    // các phiên bản đã khởi tạo trước khi file này chạy (vd. mở từ link Xem lại thiết kế)
    Array.prototype.forEach.call(document.querySelectorAll('[data-dearem-customizer]'), function (root) {
      var s = root.__dmc; if (!s) return;
      ensure(s);
      if (s.modal && s.modal.classList.contains('is-open')) { goFree(s); s.render(); }
    });
  })();

  /* ================= Customizer thêu ảnh (photo v17) ================= */
  (function () {
    var roots = document.querySelectorAll('[data-dearem-photo-customizer]');
    var proto = null;
    Array.prototype.forEach.call(roots, function (r) { if (r.__dmp && !proto) proto = Object.getPrototypeOf(r.__dmp); });
    if (!proto || proto.__emOvl) return; proto.__emOvl = 1;
    function overlaps(self) {
      var bx = self.boxes || [], a = bx.filter(function (b) { return b.line === 1; })[0], b = bx.filter(function (b2) { return b2.line === 2; })[0];
      if (!a || !b) return false;
      var tol = 2; // px trên canvas
      return !(a.x + a.w - tol <= b.x || b.x + b.w - tol <= a.x || a.y + a.h - tol <= b.y || b.y + b.h - tol <= a.y);
    }
    function free(self) {
      self.freeMode = true;
      if (self.freeBtn) self.freeBtn.style.display = 'none';
    }
    function ensure(self) {
      if (!self.modal) return;
      placeWarn(self, [self.modal.querySelector('.dmp-stage__note'), self.modal.querySelector('[data-dmp-confirm] .dmp-note') || self.modal.querySelector('.dmp-panel--confirm .dmp-note')]);
    }
    var _op = proto.open;
    proto.open = function () { free(this); var r = _op.apply(this, arguments); ensure(this); return r; };
    var _ds = proto.drawSel;
    proto.drawSel = function () {
      var r = _ds.apply(this, arguments);
      try { ensure(this); this.__emNow = overlaps(this); setWarn(this, this.__emNow); } catch (e) {}
      return r;
    };
    var _sv = proto.save;
    proto.save = function () {
      var prev = this.__emState; this.__emState = !!this.__emNow;
      var r = _sv.apply(this, arguments);
      if (!r) this.__emState = prev;
      return r;
    };
    var _wp = proto.writeProperties;
    proto.writeProperties = function () {
      var r = _wp.apply(this, arguments);
      try { if (this.state && this.__emState) addFlag(this.form); } catch (e) {}
      return r;
    };
    Array.prototype.forEach.call(roots, function (r) { if (r.__dmp) { free(r.__dmp); ensure(r.__dmp); } });
  })();
  }
  // nạp từ <head>: chờ DOMContentLoaded để các file customizer (defer) đã chạy xong
  if (document.readyState === 'complete') emRun();
  else { document.addEventListener('DOMContentLoaded', emRun); window.addEventListener('load', emRun); }
})();
